import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Message } from 'primereact/message';
import { EstadoTag, aInputFechaHora, descargarInforme, fechaHora, poli } from './poliApi';
import ArchivosPrueba from './ArchivosPrueba';
import InformeVista from './InformeVista';

/**
 * P-3 Detalle de una prueba: datos, historial y solo los botones que el perfil puede usar (los
 * calcula el servidor con las mismas reglas que valida). Es tambien la pantalla a la que llevaran los
 * enlaces de los correos.
 */
const ACCION = {
    2: { texto: 'Asignar fecha', icono: 'pi pi-calendar-plus', fecha: true },
    3: { texto: 'Pedir reprogramacion', icono: 'pi pi-replay', motivo: true },
    4: { texto: 'Reprogramar', icono: 'pi pi-calendar', fecha: true },
    5: { texto: 'Asistio', icono: 'pi pi-check' },
    9: { texto: 'No asistio', icono: 'pi pi-times' },
    10: { texto: 'Marcar no realizada', icono: 'pi pi-ban', motivo: true },
    11: { texto: 'Anular', icono: 'pi pi-trash', motivo: true, peligro: true }
};

const Dato = ({ titulo, valor }) => (
    <div className="col-12 md:col-6 lg:col-4">
        <div className="text-600 text-sm">{titulo}</div>
        <div className="font-medium">{valor || '—'}</div>
    </div>
);

const DetallePrueba = ({ pruebaId, cfg, alCerrar, alCambiar }) => {
    const [p, setP] = useState(null);
    const [accion, setAccion] = useState(null);
    const [motivo, setMotivo] = useState('');
    const [motivoLista, setMotivoLista] = useState(null);
    const [fecha, setFecha] = useState('');
    const [ciudad, setCiudad] = useState(null);
    const [poligrafista, setPoligrafista] = useState(null);
    const [poligrafistas, setPoligrafistas] = useState([]);
    const [error, setError] = useState('');
    const [ocupado, setOcupado] = useState(false);
    const [verInforme, setVerInforme] = useState(false);
    const [correos, setCorreos] = useState([]);

    const esAdmin = cfg && cfg.perfiles.includes('ADMIN');

    useEffect(() => {
        setP(null);
        setAccion(null);
        if (pruebaId) poli(`/pruebas/${pruebaId}`).then(setP).catch((e) => setError(e.message));
    }, [pruebaId]);

    useEffect(() => {
        if (esAdmin) poli('/poligrafistas').then(setPoligrafistas).catch(() => setPoligrafistas([]));
    }, [esAdmin]);

    const veAvisos = cfg && (cfg.perfiles.includes('ADMIN') || cfg.perfiles.includes('GERENCIA'));
    useEffect(() => {
        setCorreos([]);
        if (pruebaId && veAvisos) poli(`/pruebas/${pruebaId}/correos`).then(setCorreos).catch(() => setCorreos([]));
    }, [pruebaId, veAvisos, p && p.estado]); // eslint-disable-line react-hooks/exhaustive-deps

    const descargar = async () => {
        setError('');
        try {
            await descargarInforme(p.prueba_id, p.codigo);
            const r = await poli(`/pruebas/${p.prueba_id}`);
            setP(r);
            if (alCambiar) alCambiar(r);
        } catch (e) {
            setError(e.message);
        }
    };

    const abrir = (estado) => {
        setAccion(estado);
        setMotivo('');
        setMotivoLista(null);
        setError('');
        const d = new Date(Date.now() + 86400000);
        d.setHours(9, 0, 0, 0);
        setFecha(aInputFechaHora(d));
    };

    const confirmar = async () => {
        setOcupado(true);
        setError('');
        try {
            const def = ACCION[accion] || {};
            const textoMotivo = [motivoLista, motivo].filter(Boolean).join(': ');
            const r = await poli(`/pruebas/${p.prueba_id}/estado`, 'POST', {
                estado: accion,
                motivo: def.motivo ? textoMotivo : undefined,
                fechaAsignada: def.fecha ? fecha : undefined,
                ciudadId: def.fecha ? ciudad : undefined,
                poligrafistaId: def.fecha ? poligrafista : undefined
            });
            setP(r);
            setAccion(null);
            if (alCambiar) alCambiar(r);
        } catch (e) {
            setError(e.message);
        } finally {
            setOcupado(false);
        }
    };

    const catalogo = (tipo) => ((cfg && cfg.catalogos) || []).filter((c) => c.tipo === tipo && c.activo);
    const def = ACCION[accion] || {};

    return (
        <Dialog header={p ? `Prueba ${p.codigo}` : 'Prueba'} visible={!!pruebaId} style={{ width: 'min(52rem, 96vw)' }} onHide={alCerrar}>
            {error && !accion && <Message severity="error" text={error} />}
            {p && (
                <div className="flex flex-column gap-3">
                    <div className="flex align-items-center gap-3 flex-wrap">
                        <EstadoTag fila={p} />
                        {p.plazo_reagendar && <Message severity="warn" text={`Puede reagendarse hasta el ${new Date(p.plazo_reagendar + 'T12:00').toLocaleDateString('es-EC')}`} />}
                    </div>
                    <div className="grid">
                        <Dato titulo="Colaborador" valor={`${p.nombres} ${p.apellidos}`} />
                        <Dato titulo="Cedula" valor={p.cedula} />
                        <Dato titulo="Compania" valor={p.compania} />
                        <Dato titulo="Proyecto" valor={p.proyecto} />
                        <Dato titulo="Puesto" valor={p.puesto} />
                        <Dato titulo="Fecha de ingreso" valor={p.fecha_ingreso && new Date(p.fecha_ingreso + 'T12:00').toLocaleDateString('es-EC')} />
                        <Dato titulo="Tipo de prueba" valor={p.tipo_prueba} />
                        <Dato titulo="Motivo" valor={p.motivo} />
                        <Dato titulo="Solicitud" valor={`${p.solicitud}${p.nombre_grupo ? ' · ' + p.nombre_grupo : ''}`} />
                        <Dato titulo="Cita" valor={fechaHora(p.fecha_asignada)} />
                        <Dato titulo="Ciudad" valor={p.ciudad} />
                        <Dato titulo="Poligrafista" valor={p.poligrafista} />
                    </div>
                    {(p.siguientes || []).length > 0 && !accion && (
                        <div className="flex flex-wrap gap-2">
                            {p.siguientes.filter((s) => ACCION[s]).map((s) => (
                                <Button key={s} label={ACCION[s].texto} icon={ACCION[s].icono}
                                    className={ACCION[s].peligro ? 'p-button-danger p-button-outlined' : 'p-button-outlined'} onClick={() => abrir(s)} />
                            ))}
                        </div>
                    )}
                    {accion && (
                        <div className="surface-100 border-round p-3 flex flex-column gap-2">
                            <b>{def.texto}</b>
                            {def.fecha && (
                                <div className="grid">
                                    <div className="col-12 md:col-4 flex flex-column gap-1">
                                        <label htmlFor="det-fecha">Fecha y hora</label>
                                        <InputText id="det-fecha" type="datetime-local" value={fecha} onChange={(e) => setFecha(e.target.value)} />
                                    </div>
                                    <div className="col-12 md:col-4 flex flex-column gap-1">
                                        <label htmlFor="det-ciudad">Ciudad</label>
                                        <Dropdown inputId="det-ciudad" value={ciudad} showClear placeholder="Ciudad"
                                            options={catalogo('CIUDAD').map((c) => ({ label: c.nombre, value: c.catalogo_id }))} onChange={(e) => setCiudad(e.value)} />
                                    </div>
                                    <div className="col-12 md:col-4 flex flex-column gap-1">
                                        <label htmlFor="det-poligrafista">Poligrafista</label>
                                        <Dropdown inputId="det-poligrafista" value={poligrafista} showClear placeholder="Poligrafista"
                                            options={poligrafistas.map((u) => ({ label: u.nombre || u.username, value: u.usuario_id }))} onChange={(e) => setPoligrafista(e.value)} />
                                    </div>
                                </div>
                            )}
                            {def.motivo && (
                                <>
                                    {accion === 11 && (
                                        <Dropdown inputId="det-motivo-lista" value={motivoLista} placeholder="Motivo de anulacion" aria-label="Motivo de anulacion"
                                            options={catalogo('MOTIVO_ANULACION').map((c) => ({ label: c.nombre, value: c.nombre }))} onChange={(e) => setMotivoLista(e.value)} />
                                    )}
                                    <label htmlFor="det-motivo">{accion === 11 ? 'Detalle (opcional si eligio un motivo)' : 'Motivo'}</label>
                                    <InputTextarea id="det-motivo" rows={2} value={motivo} autoResize onChange={(e) => setMotivo(e.target.value)} />
                                </>
                            )}
                            {error && <Message severity="error" text={error} />}
                            <div className="flex gap-2">
                                <Button label="Confirmar" icon="pi pi-check" loading={ocupado} onClick={confirmar}
                                    disabled={def.motivo && !(motivoLista || motivo.trim().length >= 3)} />
                                <Button label="Cancelar" className="p-button-text" onClick={() => setAccion(null)} />
                            </div>
                        </div>
                    )}
                    {p.estado >= 6 && p.estado <= 8 && cfg && ['CLIENTE', 'GERENCIA', 'ADMIN', 'POLIGRAFISTA'].some((x) => cfg.perfiles.includes(x)) && (
                        <div className="flex flex-wrap gap-2">
                            <Button label="Ver informe" icon="pi pi-file" onClick={() => setVerInforme(true)} />
                            <Button label="Descargar PDF" icon="pi pi-download" className="p-button-outlined" onClick={descargar} />
                        </div>
                    )}
                    <ArchivosPrueba pruebaId={p.prueba_id}
                        puedeAdjuntar={cfg && (cfg.perfiles.includes('CLIENTE') || cfg.perfiles.includes('ADMIN')) && (p.estado <= 4 || p.estado === 9)} />
                    {veAvisos && correos.length > 0 && (
                        <div>
                            <h5 className="mb-2">Avisos por correo</h5>
                            {correos.map((c, i) => (
                                <div key={i} className="text-sm py-1 border-bottom-1 surface-border">
                                    <span className="text-600">{fechaHora(c.fecha)}</span> · {c.asunto} · <b>{{ ENVIADO: 'Enviado', DESACTIVADO: 'Correos apagados', SIN_DESTINATARIOS: 'Sin destinatarios', ERROR: 'Error' }[c.resultado] || c.resultado}</b>
                                    {c.destinatarios && <span className="text-600"> · {c.destinatarios.split(';').length} destinatarios</span>}
                                </div>
                            ))}
                        </div>
                    )}
                    <div>
                        <h5 className="mb-2">Historial</h5>
                        {(p.historial || []).map((h, i) => (
                            <div key={i} className="flex gap-3 py-2 border-bottom-1 surface-border">
                                <small className="text-600" style={{ minWidth: '9rem' }}>{fechaHora(h.fecha)}</small>
                                <div>
                                    <b>{h.estado_nombre}</b> · {h.usuario || 'Sistema'}
                                    {h.fecha_asignada && <span> · cita {fechaHora(h.fecha_asignada)}</span>}
                                    {h.motivo && <div className="text-700">{h.motivo}</div>}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
            <InformeVista pruebaId={p && p.prueba_id} visible={verInforme} esGerencia={cfg && cfg.perfiles.includes('GERENCIA')}
                alCerrar={() => { setVerInforme(false); if (p) poli(`/pruebas/${p.prueba_id}`).then((r) => { setP(r); if (alCambiar) alCambiar(r); }).catch(() => {}); }} />
        </Dialog>
    );
};

export default DetallePrueba;
